import React from 'react';

//components
import Icon from '../icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';

//styling
import '../../../css/search/simpleSearchInput.scss';



const SimpleSearchInput = ({className, ariaLabel, setSearchString, searchString, isDisabled} : {className?: string, ariaLabel: string, setSearchString: (searchString: string) => void, searchString: string, isDisabled?: boolean}) => {
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchString(event.target.value);
    };

    return (
        <div className={`search-string-input-container ${className}`}>
            <Icon iconName={IconLibrary.SEARCH_GLASS} color='var(--thriveGrey)' sizeInPx='16'/>

            <input 
                id="simple-search-input" 
                type='text' 
                title="Search Input" 
                value={searchString} 
                placeholder="Search" 
                onInput={handleInputChange} 
                disabled={isDisabled} 
            />
            
            <label htmlFor="simple-search-input" className='sr-only'>{ariaLabel}</label>
        </div> 
    )
}

export default SimpleSearchInput